import { AfterViewChecked, Component, OnInit, TemplateRef, viewChild, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FormService } from '../../services/form.service';
import { Form } from '../../data/form';
import { WebAuthService } from '@rbb/ng-web-auth-lib';
import {
  AdUser,
  BrowserMessage,
  BrowserMessagesService,
  BrowserMessageType,
  ModalRef,
  ModalService,
  Step,
  UserService,
  LoaderComponent, SideMenuHeadlineComponent, StepsComponent, PeoplePickerComponent, MultiValueInputComponent, MultiSelectComponent
} from '@rbb/ng-web-template-lib';
import { ApproverType, getAllApproverTypeValues, getLocalizedNameOfApproverType } from '../../types/approver-type';
import { Field } from '../../data/field';
import { FieldType } from '../../types/field-type';
import { BodyForm } from '../../body/body-form';
import { ApproverDataToJson } from '../../data-to-json/approver-data-to-json';
import { OrgUnitType } from '../../types/org-unit-type';
import { TextFieldParameter } from '../../custom-field-parameter/text-field-parameter';
import { ClientFieldParameter } from '../../custom-field-parameter/client-field-parameter';
import { EmployeeTypeFieldParameter } from '../../custom-field-parameter/employee-type-field-parameter';
import { EmyployeeNumberFieldParameter } from '../../custom-field-parameter/emyployee-number-field-parameter';
import { MobileFieldParameter } from '../../custom-field-parameter/mobile-field-parameter';
import { OrgUnitFieldParameter } from '../../custom-field-parameter/org-unit-field-parameter';
import { RoomFieldParameter } from '../../custom-field-parameter/room-field-parameter';
import { SelectionFieldParameter } from '../../custom-field-parameter/selection-field-parameter';
import { TableFieldParameter } from '../../custom-field-parameter/table-field-parameter';
import { TelephoneFieldParameter } from '../../custom-field-parameter/telephone-field-parameter';
import { FaxFieldParameter } from '../../custom-field-parameter/fax-field-parameter';
import { YesNoFieldParameter } from '../../custom-field-parameter/yes-no-field-parameter';
import { ListFieldParameter } from '../../custom-field-parameter/list-field-parameter';
import { ActionFormData } from '../../custom-field-parameter/action-form-data';
import { ApproverFormData } from '../../custom-field-parameter/approver-form-data';
import { NumberFieldParameter } from '../../custom-field-parameter/number-field-parameter';
import { EmailFieldParameter } from '../../custom-field-parameter/email-field-parameter';
import { EmployeeService } from '../../services/employee.service';
import { HeaderFieldParameter } from '../../custom-field-parameter/header-field-parameter';
import { DescriptionFieldParameter } from '../../custom-field-parameter/description-field-parameter';
import { DateFieldParameter } from '../../custom-field-parameter/date-field-parameter';
import { environment } from '../../../environments/environment';
import { FileFieldParameter } from '../../custom-field-parameter/file-field-parameter';
import { BlankSpaceFieldParameter } from '../../custom-field-parameter/blank-space-field-parameter';
import { SelectionPlusFieldParameter } from '../../custom-field-parameter/selection-plus-field-parameter';
import { cloneDeep, isEqual, uniq } from 'lodash';
import { SeparatorLineFieldParameter } from '../../custom-field-parameter/separator-line-field-parameter';
import { GroupFieldParameter } from '../../custom-field-parameter/group-field-parameter';
import { UtilService } from '../../services/util.service';
import { TimeFieldParameter } from '../../custom-field-parameter/time-field-parameter';
import { ActionType } from '../../types/action-type';
import { PeriodFieldParameter } from '../../custom-field-parameter/period-field-parameter';
import { PercentFieldParameter } from '../../custom-field-parameter/percent-field-parameter';
import { PersonFieldParameter } from '../../custom-field-parameter/person-field-parameter';
import { PersonListFieldParameter } from '../../custom-field-parameter/person-list-field-parameter';
import { AccountFieldParameter } from '../../custom-field-parameter/account-field-parameter';
import { PeriodsFieldParameter } from '../../custom-field-parameter/periods-field-parameter';
import { MobileWorkAgreementFieldParameter } from '../../custom-field-parameter/mobile-work-agreement-field-parameter';
import { DisabilityStatusFieldParameter } from '../../custom-field-parameter/disability-status-field-parameter';
import { ProductionUnitFieldParameter } from '../../custom-field-parameter/production-unit-field-parameter';
import { FormListItem } from '../../data/form-list-item';
import { SelectionTableFieldParameter } from '../../custom-field-parameter/selection-table-field-parameter';
import { ConditionalType } from '../../types/conditional-type';
import { FormsModule } from '@angular/forms';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';
import { FormDiffComponent } from '../form-diff/form-diff.component';
import { FormComponent } from '../form/form.component';

@Component({
  selector: 'app-editor-form',
  templateUrl: './editor-form.component.html',
  styleUrls: ['./editor-form.component.css'],
  imports: [FormsModule, PrivacyPolicyComponent, FormDiffComponent, FormComponent, RouterLink, LoaderComponent, SideMenuHeadlineComponent, StepsComponent, PeoplePickerComponent, MultiValueInputComponent, MultiSelectComponent]
})
export class EditorFormComponent implements OnInit, AfterViewChecked {
  private route = inject(ActivatedRoute);
  private formService = inject(FormService);
  private webAuthService = inject(WebAuthService);
  private employeeService = inject(EmployeeService);
  private router = inject(Router);
  private browserMessagesService = inject(BrowserMessagesService);
  private userService = inject(UserService);
  private modalService = inject(ModalService);
  private utilService = inject(UtilService);

  environment = environment;
  isEqual = isEqual;
  webUrl = environment.webUrl;
  dataProtectionOfficer = environment.dataProtectionOfficer;
  transferSystems = [] as { name: string; url: string; forms?: FormListItem[] }[];
  newTag = '';

  id: string | undefined;
  form: Form | undefined;
  oldForm: Form | undefined;
  previewForm: Form | undefined;

  haMit = false;
  admin = false;

  dataFields = [''];
  approver: AdUser[] = [];
  owners: AdUser[] = [];
  operators: AdUser[] = [];
  readers: AdUser[] = [];
  tester: AdUser[] = [];
  currentStep = 1;

  error = '';

  steps: Step[] = [
    { name: 'Allgemein', func: (): void => this.changeCurrentStep(1), disabled: false },
    { name: 'Datenfelder', func: (): void => this.changeCurrentStep(2), disabled: false },
    { name: 'Datenschutz', func: (): void => this.changeCurrentStep(3), disabled: true },
    { name: 'Vorschau und Speichern', func: (): void => this.changeCurrentStep(4), disabled: true }
  ];

  readonly ngModal = viewChild<TemplateRef<unknown>>('ngModal');
  ngModalService: ModalRef<unknown> | undefined;

  readonly ngModalCopy = viewChild<TemplateRef<unknown>>('ngModalCopy');
  ngModalCopyService: ModalRef<unknown> | undefined;

  readonly ngModalSave = viewChild<TemplateRef<unknown>>('ngModalSave');
  ngModalSaveService: ModalRef<unknown> | undefined;

  /*
  private static distance(x1: number, y1: number, x2: number, y2: number): number {
    const a = x1 - x2;
    const b = y1 - y2;
    return Math.sqrt( a * a + b * b );
  }
   */

  ngOnInit(): void {
    this.id = this.route.snapshot.params['id'];
    if (this.id === 'new') {
      this.form = new Form();
      this.form.name = '';
      this.form.tag = '';
      this.form.timestamp = new Date();
      this.form.visibleForGroups = [];
      this.form.owners = this.webAuthService.authUser?.username ? [this.webAuthService.authUser.username] : [];
      this.form.operators = [];
      this.form.readers = [];
      this.form.actionType = null;
      this.form.actionDataCustomParameter = new ActionFormData(undefined);
      this.form.approverTypes = [];
      this.form.approverDataCustomParameter = [];
      this.form.orderedApprovals = true;
      this.form.actionData = '';
      this.form.storagePeriod = 6;
      this.form.orgUnitType = OrgUnitType.MAIN_DEPARTMENT;
      this.form.fields = [
        {
          id: '57f85315-972f-4c37-a462-e438fc2df1d8',
          name: 'Wichtige Hinweise',
          description: '',
          tag: null,
          required: true,
          conditionalType: null,
          conditionalTerms: [],
          presented: false,
          type: FieldType.HEADER,
          definition: '{}',
          columnWidth: 6,
          order: 1,
          fieldCustomParameter: {}
        },
        {
          id: 'e50e3c31-0701-4111-b644-4adf75eef333',
          name: 'Hinweistext',
          description: '',
          tag: null,
          required: true,
          conditionalType: null,
          conditionalTerms: [],
          presented: false,
          type: FieldType.DESCRIPTION,
          definition: '{"value":"Liebe Kolleginnen und Kollegen,  (Persönliche Anrede - bitte übernehmen - UX-Standard für rbb-Formulare)\\n\\nmit diesem Formular können sie **xy** beantragen. (Zweck des Formulars - bitte übernehmen und ergänzen - UX-Standard für rbb-Formulare)\\n\\nHier können Sie bei Bedarf **__allgemeine__ wichtige Ausfüll-Hinweise** und/oder **Hinweise auf hausinterne Regelwerke** einpflegen.\\n\\nBitte füllen Sie dieses Formular sorgfältig und vollständig aus. Nur so können wir es zügig und ohne Rückfragen bearbeiten. (Unterstützung - - bitte übernehmen - UX-Standard für rbb-Formulare)\\n\\nVielen Dank für Ihre Unterstützung.\\nIhre (Fachteam ergänzen - bitte übernehmen - UX-Standard für rbb-Formulare)"}',
          columnWidth: 12,
          order: 2,
          fieldCustomParameter: {
            value: 'Liebe Kolleginnen und Kollegen,  (Persönliche Anrede - bitte übernehmen - UX-Standard für rbb-Formulare)\n\nmit diesem Formular können sie **xy** beantragen. (Zweck des Formulars - bitte übernehmen und ergänzen - UX-Standard für rbb-Formulare)\n\nHier können Sie bei Bedarf **__allgemeine__ wichtige Ausfüll-Hinweise** und/oder **Hinweise auf hausinterne Regelwerke** einpflegen.\n\nBitte füllen Sie dieses Formular sorgfältig und vollständig aus. Nur so können wir es zügig und ohne Rückfragen bearbeiten. (Unterstützung - - bitte übernehmen - UX-Standard für rbb-Formulare)\n\nVielen Dank für Ihre Unterstützung.\nIhre (Fachteam ergänzen - bitte übernehmen - UX-Standard für rbb-Formulare)'
          }
        },
        {
          id: '11a252da-983c-4aaf-8a18-e36f92c0b923',
          name: 'Personenbezogene Daten',
          description: '',
          tag: null,
          required: true,
          conditionalType: null,
          conditionalTerms: [],
          presented: false,
          type: FieldType.HEADER,
          definition: '{}',
          columnWidth: 6,
          order: 3,
          fieldCustomParameter: {}
        },
        {
          id: '8e4654c1-849a-4813-b06b-79f9ae24038f',
          name: 'Platzhalter 1',
          description: 'Dies ist ein **Platzhalter**. Im Abschnitt "Personenbezogene Daten" finden sich alle Datenfelder, die personenbezogene Daten erheben. Zum Beispiel "Telefonnummer", "E-Mail" "Bereich", "Kostenstelle" etc. Bitte denken Sie daran, unter **jedes Datenfeld** eine **Handlungsanweisung** für die Antragstellenden zu setzen. Wichtige Passagen bitte **fetten**.',
          tag: null,
          required: true,
          conditionalType: null,
          conditionalTerms: [],
          presented: true,
          type: FieldType.TEXT,
          definition: '{"rows":1}',
          columnWidth: 6,
          order: 4,
          fieldCustomParameter: {
            rows: 1
          }
        },
        {
          id: '5d8bc3fc-0bbc-4fcd-a366-43a48b4f20f3',
          name: 'Platzhalter 2',
          description: 'Dies ist ein **Platzhalter**. Im Abschnitt "Personenbezogene Daten" finden sich alle Datenfelder, die personenbezogene Daten erheben. Zum Beispiel "Telefonnummer", "E-Mail" "Bereich", "Kostenstelle" etc. Bitte denken Sie daran, unter **jedes Datenfeld** eine **Handlungsanweisung** für die Antragstellenden zu setzen. Wichtige Passagen bitte **fetten**.',
          tag: null,
          required: true,
          conditionalType: null,
          conditionalTerms: [],
          presented: true,
          type: FieldType.TEXT,
          definition: '{"rows":1}',
          columnWidth: 6,
          order: 5,
          fieldCustomParameter: {
            rows: 1
          }
        },
        {
          id: '19775de4-c692-4f27-9528-b3bbf9cd7455',
          name: 'Angaben zum Antrag',
          description: '',
          tag: null,
          required: true,
          conditionalType: null,
          conditionalTerms: [],
          presented: false,
          type: FieldType.HEADER,
          definition: '{}',
          columnWidth: 6,
          order: 6,
          fieldCustomParameter: {
            rows: 1
          }
        },
        {
          id: 'e39d04df-58ff-4437-b756-aa0a24f772f7',
          name: 'Platzhalter 3',
          description: 'Dies ist ein **Platzhalter**. Im Abschnitt " Angaben zum Antrag" befinden sich alle Datenfelder, in denen Antragstellende nähere Angaben zu ihrem Antrag machen (Logistische Infos, Technische Infos etc. ) Bitte denken Sie daran, unter jedes Datenfeld eine **Handlungsanweisung** für die Antragstellenden zu setzen. Wichtige Passagen bitte **fetten**.',
          tag: null,
          required: true,
          conditionalType: null,
          conditionalTerms: [],
          presented: true,
          type: FieldType.TEXT,
          definition: '{"rows":1}',
          columnWidth: 6,
          order: 7,
          fieldCustomParameter: {
            rows: 1
          }
        },
        {
          id: 'de0f87a0-8d38-41b8-9bb2-ba46b44f1d60',
          name: 'Platzhalter 4',
          description: 'Dies ist ein **Platzhalter**. Im Abschnitt " Angaben zum Antrag" befinden sich alle Datenfelder, in denen Antragstellende nähere Angaben zu ihrem Antrag machen (Logistische Infos, Technische Infos etc. ) Bitte denken Sie daran, unter jedes Datenfeld eine **Handlungsanweisung** für die Antragstellenden zu setzen. Wichtige Passagen bitte **fetten**.',
          tag: null,
          required: true,
          conditionalType: null,
          conditionalTerms: [],
          presented: true,
          type: FieldType.TEXT,
          definition: '{"rows":1}',
          columnWidth: 6,
          order: 7,
          fieldCustomParameter: {
            rows: 1
          }
        }
      ];
      this.form.dataFieldsCustomParameter = this.dataFields;
      this.userService.getAdUsers(this.form.owners).subscribe({
        next: (owners) => {
          this.owners = owners;
        },
        error: (error) => {
          this.browserMessagesService.showHttpError(error, 'Daten zu den Verantwortlichen konnten nicht geladen werden');
        }
      });
    } else if (this.id) {
      this.getForm(this.id);
    }
    this.employeeService.getMyApprovers().subscribe(
      (next) => {
        this.haMit = next.mainDepartment?.includes('Mediensysteme und IT') ?? false;
        this.admin = next.admin ?? false;
        if (next.admin) {
          this.transferSystems = environment.transferSystems;
          for (const transferSystem of this.transferSystems) {
            this.formService.getEditableForms(transferSystem.url).subscribe(data => transferSystem.forms = data);
          }
        }
      }
    );
  }

  ngAfterViewChecked(): void {
    document.querySelectorAll('app-editor-form input:not(.websocket-initialized), app-editor-form select:not(.websocket-initialized), app-editor-form textarea:not(.websocket-initialized)').forEach((el) => {
      el.classList.add('websocket-initialized');
      el.addEventListener('change', () => this.sendWebSocketForm());
    });
  }

  changeCurrentStep(stepNumber: number): void {
    if (stepNumber === 4) {
      this.previewForm = cloneDeep(this.form);
    }
    let e = '';
    if (stepNumber > this.currentStep) {
      e = this.pageError(this.currentStep);
    }
    this.error = e;
    if (!e) {
      window.scrollTo(0, 0);
      this.currentStep = stepNumber;
    }
    for (let i = 0; i < this.steps.length; i++) {
      this.steps[i].disabled = i > this.currentStep;
    }
  }

  getForm(id: string): void {
    this.formService.getForm(id).subscribe({
      next: (next) => {
        this.form = next;
        this.form.timestamp = new Date();
        this.form.actionDataCustomParameter = new ActionFormData(this.form.actionData);
        if (this.form.owners) {
          this.userService.getAdUsers(this.form.owners).subscribe({
            next: (owners) => {
              this.owners = owners;
            },
            error: (error) => {
              this.browserMessagesService.showHttpError(error, 'Daten zu den Verantwortlichen konnten nicht geladen werden');
            }
          });
        }
        if (this.form.operators) {
          this.userService.getAdUsers(this.form.operators).subscribe({
            next: (operators) => {
              this.operators = operators;
            },
            error: (error) => {
              this.browserMessagesService.showHttpError(error, 'Daten zu den Bearbeitern konnten nicht geladen werden');
            }
          });
        }
        if (this.form.readers) {
          this.userService.getAdUsers(this.form.readers).subscribe({
            next: (readers) => {
              this.readers = readers;
            },
            error: (error) => {
              this.browserMessagesService.showHttpError(error, 'Daten zu den Leseberechtigungen konnten nicht geladen werden');
            }
          });
        }
        if (this.form.tester) {
          this.userService.getAdUsers(this.form.tester).subscribe({
            next: (tester) => {
              this.tester = tester;
            },
            error: (error) => {
              this.browserMessagesService.showHttpError(error, 'Daten zu den Testberechtigungen konnten nicht geladen werden');
            }
          });
        }

        const tmpApproverData: ApproverFormData[] = this.form.approverData ? JSON.parse(this.form.approverData) : [];
        this.form.approverDataCustomParameter = new Array<ApproverDataToJson>(tmpApproverData.length);
        for (let i = 0; i < tmpApproverData.length; i++) {
          const data = tmpApproverData[i];
          if (!data) {
            this.form.approverDataCustomParameter[i] = new ApproverDataToJson();
          } else {
            const tmpUser = new ApproverDataToJson();
            this.form.approverDataCustomParameter[i] = tmpUser;
            tmpUser.limit = data.limit ?? null;
            tmpUser.forInformationOnly = data.forInformationOnly;

            // GroupMember
            const groupMemberUsernames = [];
            if (data.groupMember && this.form.approverTypes?.[i] === ApproverType.APPROVER_GROUP) {
              tmpUser.mailNotification = data.mailNotification;

              for (const member of data.groupMember) {
                if (member.username != null) {
                  groupMemberUsernames.push(member.username);
                }
              }
            }

            if (groupMemberUsernames) {
              this.userService.getAdUsers(groupMemberUsernames).subscribe({
                next: (approver) => {
                  tmpUser.groupMembers = approver;
                },
                error: (error) => {
                  this.browserMessagesService.showHttpError(error, 'Daten zu den Genehmigern konnten nicht geladen werden');
                }
              });
            }

            // Genehmiger
            const username = tmpApproverData[i].username;
            if (username) {
              this.userService.getAdUsers([username]).subscribe({
                next: (approver) => {
                  tmpUser.users = approver;
                },
                error: (error) => {
                  this.browserMessagesService.showHttpError(error, 'Daten zu den Genehmigern konnten nicht geladen werden');
                }
              });
            }

            // Deputy
            const deputyUsername = tmpApproverData[i].deputyUsername;
            if (deputyUsername) {
              this.userService.getAdUsers([deputyUsername]).subscribe({
                next: (approver) => {
                  tmpUser.deputyUsers = approver;
                },
                error: (error) => {
                  this.browserMessagesService.showHttpError(error, 'Daten zu den Genehmigern konnten nicht geladen werden');
                }
              });
            }
          }
        }
        this.dataFields = this.form.dataFields ? JSON.parse(this.form.dataFields) : [''];
        this.form.dataFieldsCustomParameter = this.dataFields;
        if (this.form.fields) {
          for (let i = 0; i < this.form.fields.length; i++) {
            this.form.fields[i].fieldCustomParameter = JSON.parse(this.form.fields[i].definition ?? '{}');
            this.form.fields[i].order = i + 1;
          }
        }

        this.oldForm = cloneDeep(this.form);
      },
      error: (error) => {
        this.browserMessagesService.showHttpError(error, 'Formular konnte nicht geladen werden');
      }
    });
  }

  ownersChanged(): void {
    if (this.form) {
      this.form.owners = this.owners.map(o => o.username).filter(s => s) as string[];
    }
  }

  operatorsChanged(): void {
    if (this.form) {
      this.form.operators = this.operators.map(o => o.username).filter(s => s) as string[];
    }
  }

  readersChanged(): void {
    if (this.form) {
      this.form.readers = this.readers.map(o => o.username).filter(s => s) as string[];
    }
  }

  testerChanged(): void {
    if (this.form) {
      this.form.tester = this.tester.map(o => o.username).filter(s => s) as string[];
    }
  }

  changeActiveDirectories(field: Field, activeDirectory: string): void {
    if (!field.fieldCustomParameter.activeDirectories) {
      field.fieldCustomParameter.activeDirectories = [];
    }

    if (field.fieldCustomParameter.activeDirectories.includes(activeDirectory)) {
      const index: number = field.fieldCustomParameter.activeDirectories.indexOf(activeDirectory);
      if (index !== -1) {
        field.fieldCustomParameter.activeDirectories.splice(index, 1);
      }
    } else {
      field.fieldCustomParameter.activeDirectories.push(activeDirectory);
    }
  }

  changeEmployeeTypes(field: Field, employeeType: string): void {
    if (!field.fieldCustomParameter.employeeTypes) {
      field.fieldCustomParameter.employeeTypes = [];
    }

    if (field.fieldCustomParameter.employeeTypes.includes(employeeType)) {
      const index: number = field.fieldCustomParameter.employeeTypes.indexOf(employeeType);
      if (index !== -1) {
        field.fieldCustomParameter.employeeTypes.splice(index, 1);
      }
    } else {
      field.fieldCustomParameter.employeeTypes.push(employeeType);
    }
  }

  addApproverType(): void {
    if (this.form?.approverDataCustomParameter && this.form.approverTypes) {
      this.form.approverDataCustomParameter.push(new ApproverDataToJson());
      if (!this.form.approverTypes.includes(ApproverType.CHIEF) && !this.form.approverTypes.includes(ApproverType.CHIEF_AND_DEPUTY)) {
        this.form.approverTypes.push(ApproverType.CHIEF_AND_DEPUTY);
        return;
      }
      if (!this.form.approverTypes.includes(ApproverType.COST_CENTRE_RESPONSIBLE) && !this.form.approverTypes.includes(ApproverType.COST_CENTRE_RESPONSIBLE_AND_DEPUTY)) {
        this.form.approverTypes.push(ApproverType.COST_CENTRE_RESPONSIBLE_AND_DEPUTY);
        return;
      }
      if (!this.form.approverTypes.includes(ApproverType.DEPARTMENT_CHIEF) && !this.form.approverTypes.includes(ApproverType.DEPARTMENT_CHIEF_AND_DEPUTY)) {
        this.form.approverTypes.push(ApproverType.DEPARTMENT_CHIEF_AND_DEPUTY);
        return;
      }
      if (!this.form.approverTypes.includes(ApproverType.MAIN_DEPARTMENT_CHIEF) && !this.form.approverTypes.includes(ApproverType.MAIN_DEPARTMENT_CHIEF_AND_DEPUTY)) {
        this.form.approverTypes.push(ApproverType.MAIN_DEPARTMENT_CHIEF_AND_DEPUTY);
        return;
      }
      if (!this.form.approverTypes.includes(ApproverType.DIRECTOR) && !this.form.approverTypes.includes(ApproverType.DIRECTOR_AND_DEPUTY)) {
        this.form.approverTypes.push(ApproverType.DIRECTOR_AND_DEPUTY);
        return;
      }
      if (!this.form.approverTypes.includes(ApproverType.DESIGNATED_APPROVER)) {
        this.form.approverTypes.push(ApproverType.DESIGNATED_APPROVER);
        return;
      }
      if (!this.form.approverTypes.includes(ApproverType.APPROVER_GROUP)) {
        this.form.approverTypes.push(ApproverType.APPROVER_GROUP);
        return;
      }
      if (!this.form.approverTypes.includes(ApproverType.SELECTED_APPROVER)) {
        this.form.approverTypes.push(ApproverType.SELECTED_APPROVER);
        return;
      }
    }
  }

  removeApproverType(): void {
    if (this.form?.approverDataCustomParameter && this.form.approverTypes && this.form.approverTypes.length > 0) {
      this.form.approverTypes.pop();
      this.form.approverDataCustomParameter.pop();
    }
  }

  addField(i: number | undefined): void {
    if (this.form?.fields && i !== undefined) {
      const tmpField = new Field();
      tmpField.columnWidth = 6;
      tmpField.required = true;
      tmpField.conditionalType = null;
      tmpField.conditionalTerms = [];
      tmpField.presented = false;
      tmpField.type = FieldType.TEXT;
      tmpField.fieldCustomParameter = new TextFieldParameter();
      tmpField.order = this.form.fields.length + 1;
      tmpField.name = '';
      tmpField.description = '';
      tmpField.definition = '';
      if (this.form.fields.length === i) {
        this.form.fields.push(tmpField);
      } else {
        this.form.fields.splice(i, 0, tmpField);
        let n = 1;
        for (const f of this.form.fields) {
          f.order = n;
          n++;
        }
      }
    }
  }

  changeCustomParameter(field: Field): void {
    switch (field.type) {
      case FieldType.TEXT:
        field.fieldCustomParameter = new TextFieldParameter();
        break;
      case FieldType.NUMBER:
        field.fieldCustomParameter = new NumberFieldParameter();
        break;
      case FieldType.CLIENT:
        field.fieldCustomParameter = new ClientFieldParameter();
        break;
      case FieldType.COST_CENTRE:
        field.fieldCustomParameter = new ClientFieldParameter();
        break;
      case FieldType.EMPLOYEE_TYPE:
        field.fieldCustomParameter = new EmployeeTypeFieldParameter();
        break;
      case FieldType.EMPLOYEE_NUMBER:
        field.fieldCustomParameter = new EmyployeeNumberFieldParameter();
        break;
      case FieldType.MOBILE_WORK_AGREEMENT:
        field.fieldCustomParameter = new MobileWorkAgreementFieldParameter();
        break;
      case FieldType.DISABILITY_STATUS:
        field.fieldCustomParameter = new DisabilityStatusFieldParameter();
        break;
      case FieldType.MOBILE:
        field.fieldCustomParameter = new MobileFieldParameter();
        break;
      case FieldType.ORG_UNIT:
        field.fieldCustomParameter = new OrgUnitFieldParameter();
        break;
      case FieldType.ROOM:
        field.fieldCustomParameter = new RoomFieldParameter();
        break;
      case FieldType.SELECTION:
        field.fieldCustomParameter = new SelectionFieldParameter();
        field.fieldCustomParameter.items = [];
        field.fieldCustomParameter.items.push('');
        break;
      case FieldType.SELECTION_PLUS:
        field.fieldCustomParameter = new SelectionPlusFieldParameter();
        field.fieldCustomParameter.items = [];
        field.fieldCustomParameter.items.push('');
        break;
      case FieldType.TABLE:
        field.fieldCustomParameter = new TableFieldParameter();
        field.fieldCustomParameter.head = [];
        field.fieldCustomParameter.head.push('');
        break;
      case FieldType.SELECTION_TABLE:
        field.fieldCustomParameter = new SelectionTableFieldParameter();
        field.fieldCustomParameter.options = [];
        field.fieldCustomParameter.options.push('');
        field.fieldCustomParameter.items = [];
        field.fieldCustomParameter.items.push('');
        break;
      case FieldType.DATE:
        field.fieldCustomParameter = new DateFieldParameter();
        break;
      case FieldType.TIME:
        field.fieldCustomParameter = new TimeFieldParameter();
        break;
      case FieldType.PERIOD:
        field.fieldCustomParameter = new PeriodFieldParameter();
        break;
      case FieldType.PERCENT:
        field.fieldCustomParameter = new PercentFieldParameter();
        break;
      case FieldType.TELEPHONE:
        field.fieldCustomParameter = new TelephoneFieldParameter();
        break;
      case FieldType.FAX:
        field.fieldCustomParameter = new FaxFieldParameter();
        break;
      case FieldType.YES_NO:
        field.fieldCustomParameter = new YesNoFieldParameter();
        break;
      case FieldType.LIST:
        field.fieldCustomParameter = new ListFieldParameter();
        break;
      case FieldType.PERIODS:
        field.fieldCustomParameter = new PeriodsFieldParameter();
        break;
      case FieldType.EMAIL:
        field.fieldCustomParameter = new EmailFieldParameter();
        break;
      case FieldType.HEADER:
        field.fieldCustomParameter = new HeaderFieldParameter();
        break;
      case FieldType.SEPARATOR_LINE:
        field.fieldCustomParameter = new SeparatorLineFieldParameter();
        break;
      case FieldType.DESCRIPTION:
        field.fieldCustomParameter = new DescriptionFieldParameter();
        break;
      case FieldType.FILE:
        field.fieldCustomParameter = new FileFieldParameter();
        field.fieldCustomParameter.fileTypes = [];
        break;
      case FieldType.BLANK_SPACE:
        field.fieldCustomParameter = new BlankSpaceFieldParameter();
        break;
      case FieldType.APPLICATION:
      case FieldType.BIMEDIAL:
      case FieldType.CAD:
      case FieldType.CONFLUENCE:
      case FieldType.FILESERVICE:
      case FieldType.GENERAL:
      case FieldType.IT:
      case FieldType.JIRA:
      case FieldType.MCLOUD:
      case FieldType.MUSIC_MASTER:
      case FieldType.PROJECT:
      case FieldType.RABBIT:
        field.fieldCustomParameter = new GroupFieldParameter();
        break;
      case FieldType.PRODUCTION_UNIT:
        field.fieldCustomParameter = new ProductionUnitFieldParameter();
        break;
      case FieldType.PERSON:
        field.fieldCustomParameter = new PersonFieldParameter();
        break;
      case FieldType.ACCOUNT:
        field.fieldCustomParameter = new AccountFieldParameter();
        break;
      case FieldType.PERSON_LIST:
        field.fieldCustomParameter = new PersonListFieldParameter();
        break;
    }
  }

  removeField(field: Field): void {
    if (this.form?.fields) {
      const id = this.form.fields.indexOf(field).valueOf();
      if (typeof this.form.fields[id + 1] !== 'undefined' && this.form.fields.length > 1) {
        this.form.fields[id + 1].order = field.order;
      }
      this.form.fields = this.form.fields.filter(item => item !== field);
    }
  }

  addCustomFieldItem(field: Field): void {
    field.fieldCustomParameter.items.push('');
  }

  removeCustomFieldItem(field: Field): void {
    if (field.fieldCustomParameter.items.length > 0) {
      field.fieldCustomParameter.items.pop();
    }
  }

  removeSpecificCustomFieldHeadItem(field: Field, pos: number): void {
    if (field.fieldCustomParameter.head.length > pos) {
      field.fieldCustomParameter.head.splice(pos, 1);
    }
  }

  removeSpecificCustomFieldItem(field: Field, pos: number): void {
    if (field.fieldCustomParameter.items.length > pos) {
      field.fieldCustomParameter.items.splice(pos, 1);
    }
  }

  removeSpecificCustomFieldOption(field: Field, pos: number): void {
    if (field.fieldCustomParameter.options.length > pos) {
      field.fieldCustomParameter.options.splice(pos, 1);
    }
  }

  addCustomFieldHeadItem(field: Field): void {
    field.fieldCustomParameter.head.push('');
  }

  removeCustomFieldHeadItem(field: Field): void {
    if (field.fieldCustomParameter.head.length > 0) {
      field.fieldCustomParameter.head.pop();
    }
  }

  addDataField(): void {
    this.dataFields.push('');
  }

  removeDataField(): void {
    if (this.dataFields.length > 0) {
      this.dataFields.pop();
    }
  }

  addCustomFieldOption(field: Field): void {
    field.fieldCustomParameter.options.push('');
  }

  removeCustomFieldOption(field: Field): void {
    if (field.fieldCustomParameter.options.length > 0) {
      field.fieldCustomParameter.options.pop();
    }
  }

  orderItem(field: Field, n: number): void {
    if (this.form?.fields && field.order) {
      const id = this.form.fields.indexOf(field).valueOf();

      if (typeof this.form.fields[id + n] !== 'undefined' && this.form.fields.length > 1) {
        this.form.fields[id + n].order = field.order;
        field.order = field.order + n;
      }
      this.form.fields = this.form.fields.sort((a, b) => (b.order ?? 0) > (a.order ?? 0) ? -1 : 1);
    }
  }

  orderDataItem(field: Field, from: number, to: number): void {
    field.fieldCustomParameter.items.splice(to, 0, field.fieldCustomParameter.items.splice(from, 1)[0]);
  }

  orderDataHead(field: Field, from: number, to: number): void {
    field.fieldCustomParameter.head.splice(to, 0, field.fieldCustomParameter.head.splice(from, 1)[0]);
  }

  orderDataOption(field: Field, from: number, to: number): void {
    field.fieldCustomParameter.options.splice(to, 0, field.fieldCustomParameter.options.splice(from, 1)[0]);
  }

  sendWebSocketForm(): void {
    if (this.form) {
      this.formService.webSocketForm(this.form).subscribe({});
    }
  }

  saveForm(): void {
    const ngModalSave = this.ngModalSave();
    if (this.form && ngModalSave) {
      this.ngModalSaveService = this.modalService.open(ngModalSave, { centered: true, backdrop: 'static' });
      if (this.id === 'new') {
        this.formService.createForm(new BodyForm(this.form)).subscribe({
          next: () => {
            this.browserMessagesService.addMessage(new BrowserMessage(
              'Gespeichert',
              'Das Formular wurde erfolgreich gespeichert.',
              BrowserMessageType.Success
            ));
            this.ngModalSaveService?.close();
            this.router.navigateByUrl('/editor').then();
          },
          error: (error) => {
            this.browserMessagesService.showHttpError(error, 'Das Formular konnte nicht gespeichert werden.');
            this.ngModalSaveService?.close();
          }
        });
      } else if (this.form.id) {
        this.formService.updateForm(new BodyForm(this.form), this.form.id).subscribe({
          next: () => {
            this.browserMessagesService.addMessage(new BrowserMessage(
              'Gespeichert',
              'Das Formular wurde erfolgreich gespeichert.',
              BrowserMessageType.Success
            ));
            this.ngModalSaveService?.close();
            this.router.navigateByUrl('/editor').then();
          },
          error: (error) => {
            this.browserMessagesService.showHttpError(error, 'Das Formular konnte nicht gespeichert werden.');
            this.ngModalSaveService?.close();
          }
        });
      }
    }
  }

  findIdInOtherSystem(systemUrl: string): string | undefined {
    return this.transferSystems.find(s => s.url === systemUrl)
      ?.forms
      ?.find(f => f.tag === this.form?.tag)
      ?.id;
  }

  transferForm(systemUrl: string): void {
    if (this.form) {
      const form: Form = cloneDeep(this.form);
      const id = this.findIdInOtherSystem(systemUrl);
      if (id) {
        form.id = id;
      } else {
        form.id = 'new';
        form.visible = false;
      }

      if (form.actionDataCustomParameter && form.actionType === ActionType.OTRS_WEBSERVICE && systemUrl.includes('tools.rbb-online.de/forms-service')) {
        form.actionDataCustomParameter.url = 'https://ardzsd.de';
      }

      if (form.actionDataCustomParameter && form.actionType === ActionType.OTRS_WEBSERVICE && systemUrl.includes('tools-s.rbb-online.de/forms-service')) {
        form.actionDataCustomParameter.url = 'https://int.ardzsd.de';
      }

      if (form.actionDataCustomParameter && form.actionType === ActionType.OTRS_WEBSERVICE && systemUrl.includes('tools-t.rbb-online.de/forms-service')) {
        form.actionDataCustomParameter.url = 'https://dev.ardzsd.de';
      }

      if (id) {
        this.formService.updateForm(new BodyForm(form), form.id, systemUrl).subscribe({
          next: (next) => {
            this.browserMessagesService.addMessage(new BrowserMessage(
              'Gespeichert',
              'Die Formularversion wurde erfolgreich transferiert.',
              BrowserMessageType.Success
            ));
            this.router.navigateByUrl('/editor').then();

            window.open(systemUrl.replace('-service', '') + '/editor/' + next, '_blank');
          },
          error: (error) => {
            this.browserMessagesService.showHttpError(error, 'Das Formular konnte nicht transferiert werden.');
          }
        });
      } else {
        this.formService.createForm(new BodyForm(form), systemUrl).subscribe({
          next: (next) => {
            this.browserMessagesService.addMessage(new BrowserMessage(
              'Gespeichert',
              'Das Formular wurde erfolgreich transferiert.',
              BrowserMessageType.Success
            ));
            this.router.navigateByUrl('/editor').then();

            window.open(systemUrl.replace('-service', '') + '/editor/' + next, '_blank');
          },
          error: (error) => {
            this.browserMessagesService.showHttpError(error, 'Das Formular konnte nicht transferiert werden.');
          }
        });
      }
    }
  }

  openCopyForm(): void {
    const ngModalCopy = this.ngModalCopy();
    if (ngModalCopy) {
      this.ngModalCopyService = this.modalService.open(ngModalCopy, { centered: true, backdrop: 'static', size: 'xl' });
    }
  }

  closeCopyForm(): void {
    this.ngModalCopyService?.close();
  }

  copyForm(): void {
    if (this.form) {
      const form: Form = cloneDeep(this.form);
      form.id = 'new';
      form.visible = false;
      form.tag = this.newTag;

      this.formService.createForm(new BodyForm(form)).subscribe({
        next: () => {
          this.closeCopyForm();
          this.browserMessagesService.addMessage(new BrowserMessage(
            'Gespeichert',
            'Das Formular wurde erfolgreich kopiert.',
            BrowserMessageType.Success
          ));
          this.router.navigateByUrl('/editor').then();
        },
        error: (error) => {
          this.closeCopyForm();
          this.browserMessagesService.showHttpError(error, 'Das Formular konnte nicht kopiert werden.');
        }
      });
    }
  }

  pageError(step: number): string {
    if (this.form) {
      if (step === 1) {
        if (!this.form.name) {
          return 'Es muss der Anzeigename angegeben werden.';
        }
        if (!this.form.groupName) {
          return 'Es muss die Kategorie angegeben werden.';
        }
        if ((this.form.owners?.length ?? 0) <= 0) {
          return 'Es muss mindestens ein Verantwortlicher angegeben werden.';
        }
        if (!this.form.tag || !/^[a-z-]+$/.exec(this.form.tag)) {
          return 'Es muss ein gültiger Tag angegeben werden (nur Kleinbuchstaben von a bis z und Bindestrich).';
        }
        if ((this.form.actionType === 'EMAIL' || this.form.actionType === 'EMAIL_DATA' || this.form.actionType === 'OTRS') && !this.form.actionDataCustomParameter?.emailAddress) {
          return 'Es muss eine gültige E-Mail Adresse angegeben werden, an der die genehmigten Anträge übermittelt werden.';
        }
        if ((this.form.actionType === 'EMAIL' || this.form.actionType === 'EMAIL_DATA' || this.form.actionType === 'OTRS') && !this.form.actionDataCustomParameter?.emailAddress?.match(/^[a-zA-Z\d\/.!#$%&’*+=?^_`{|}~-]+@[a-zA-Z\d-]+(?:\.[a-zA-Z\d-]+)+$/g)) {
          return 'Die E-Mail für die Benachrichtigung ist ungültig.';
        }
        if (this.form.actionType === 'EMAIL_DATA' && !this.form.actionDataCustomParameter?.emailAddress?.endsWith('@rbb-online.de')) {
          return 'Die E-Mail muss mit @rbb-online.de enden.';
        }
        if (this.form.actionType === 'OTRS' && !this.form.actionDataCustomParameter?.subjectTag) {
          return 'Es muss eine eindeutiger Betreff für OTRS angegeben werden.';
        }
        if (this.form.actionType === 'OTRS_WEBSERVICE' && !this.form.actionDataCustomParameter?.url) {
          return 'Es muss eine URL für OTRS angegeben werden.';
        }
        if (this.form.actionType === 'OTRS_WEBSERVICE' && !this.form.actionDataCustomParameter?.type) {
          return 'Es muss ein Typ für OTRS angegeben werden.';
        }
        if (this.form.actionType === 'OTRS_WEBSERVICE' && !this.form.actionDataCustomParameter?.service) {
          return 'Es muss ein Service für OTRS angegeben werden.';
        }
        if (this.form.actionType === 'OTRS_WEBSERVICE' && !this.form.actionDataCustomParameter?.queue) {
          return 'Es muss eine Queue für OTRS angegeben werden.';
        }
        if (this.form.actionType === 'WEBHOOK' && !this.form.actionDataCustomParameter?.url) {
          return 'Es muss eine URL für den Webhook angegeben werden.';
        }
        if (this.form.actionType === 'WEBHOOK' && !this.form.actionDataCustomParameter?.url?.startsWith('https://')) {
          return 'Die URL für den Webhook muss mit https:// anfangen.';
        }
        if (!this.form.orgUnitName) {
          return 'Es muss der Name der Fachabteilung angegeben werden.';
        }
        if (!this.form.orgUnitType) {
          return 'Es muss angegeben werden, ob die Fachabteilung eine Abteilung oder eine Hauptabteilung ist.';
        }
        if (!this.form.contactEmail) {
          return 'Es muss eine E-Mail-Adresse angegeben werden, über die ein Mitarbeiter die Fachabteilung erreichen kann.';
        }
        if (!this.form.contactEmail.match(/^[a-zA-Z\d\/.!#$%&’*+=?^_`{|}~-]+@[a-zA-Z\d-]+(?:\.[a-zA-Z\d-]+)+$/g)) {
          return 'Die E-Mail der Fachabteilung ist ungültig.';
        }
        if (!this.form.storagePeriod || this.form.storagePeriod <= 0) {
          return 'Es muss die Speicherdauer in Jahren angegeben werden.';
        }
        if (this.form.storagePeriod < 6 && !this.admin && this.form.storagePeriod !== this.oldForm?.storagePeriod) {
          return 'Die Speicherdauer muss mindestens 6 Jahre sein.';
        }
        const usedUsernames = [] as string[];
        if (this.form.approverTypes) {
          if (!this.form.approverDataCustomParameter) {
            return 'Interner Fehler';
          }
          if (this.form.approverTypes.length === 1 && this.form.approverTypes[0] === ApproverType.SELECTED_APPROVER) {
            return 'Der Genehmigungsweg darf nicht nur aus dem Schritt "Ausgewählte/r Genehmiger/in" bestehen.';
          }
          for (let i = 0; i < this.form.approverTypes.length; i++) {
            const approverData = this.form.approverDataCustomParameter[i];

            if (approverData.forInformationOnly && !approverData.limit) {
              return 'Wenn zur Kenntnisnahme aktiviert ist, muss ein Limit für die automatische zur Kenntnisnahme angegeben werden.';
            }

            if (approverData.limit && (approverData.limit < 7 || approverData.limit > 30)) {
              return 'Das Limit zur automatischen Genehmigung muss zwischen 7 und 30 Tagen liegen.';
            }

            if (this.form.approverTypes[i] === ApproverType.APPROVER_GROUP) {
              if (approverData && approverData.groupMembers.length < 3) {
                return 'Bei einer Genehmigungsgruppe müssen mehr als 2 Personen ausgewählt werden.';
              }
            }

            if (this.form.approverTypes[i] === ApproverType.DESIGNATED_APPROVER) {
              if (approverData && approverData.users.length !== 1) {
                return 'Bei einem festgelegten Genehmiger muss eine Person ausgewählt werden.';
              }
              const username = approverData.users[0].username;
              if (username) {
                if (usedUsernames.includes(username)) {
                  return 'Eine ausgewählte Person bei festgelegter Genehmiger darf nicht doppelt vorkommen.';
                }
                usedUsernames.push(username);
              }
              if (approverData.deputyUsers.length === 1) {
                const deputyUsername = approverData.deputyUsers[0].username;
                if (deputyUsername) {
                  if (usedUsernames.includes(deputyUsername)) {
                    return 'Eine ausgewählte Person bei festgelegter Genehmiger darf nicht doppelt vorkommen.';
                  }
                  usedUsernames.push(deputyUsername);
                }
              }
              if (approverData.limit && approverData.limit < 1) {
                return 'Die Anzahl der Tage muss mindestens 1 sein.';
              }
              if (approverData.limit && approverData.limit > 30) {
                return 'Die Anzahl der Tage darf maximal 30 sein.';
              }
            }
          }
        }
      }
      if (step === 2) {
        let presented = false;
        if (this.form.fields) {
          for (let i = 0; i < this.form.fields.length; i++) {
            const field = this.form.fields[i];
            const n = i + 1;
            if (!field.name) {
              return 'Datenfeld ' + n + ' benötigt einen Namen.';
            }
            if (field?.tag && !/^[a-z-]+$/.exec(field.tag)) {
              return 'Datenfeld ' + n + ' benötigt einen gültigen Tag (nur Kleinbuchstaben von a bis z und Bindestrich).';
            }
            if (field.conditionalType && !field.conditionalTerms?.length) {
              return 'Datenfeld ' + n + ' benötigt Bedingungsterme.';
            }
            const possibleTerms = this.getAvailableConditionalTermsByDefinition({ fields: this.form.fields, index: i });
            for (const term of field.conditionalTerms ?? []) {
              if (!possibleTerms.includes(term)) {
                return 'Datenfeld ' + n + ' besitzt nicht einen oder mehrere nicht mehr gültige Bedingungsterme.';
              }
            }
            if (field.type === 'PERCENT') {
              if (!field.fieldCustomParameter.absoluteHundred) {
                return 'Bei Datenfeld ' + n + ' muss der Wert für 100% angegeben werden.';
              }
              if (field.fieldCustomParameter.timeFormat && !field.fieldCustomParameter.absoluteHundred.match(/^[0-9]+:([0-5][0-9])$/)) {
                return 'Bei Datenfeld ' + n + ' muss der Wert für 100% das Format 0:00 haben.';
              }
            }
            if (field.type === 'TEXT') {
              if (!field.fieldCustomParameter.rows) {
                return 'Bei Datenfeld ' + n + ' muss die Anzahl der Zeilen angegeben werden.';
              }
              if (field.fieldCustomParameter.regex) {
                if (!field.fieldCustomParameter.regexErrorMessage) {
                  return 'Bei Datenfeld ' + n + ' muss eine Regex Fehlermeldung angegeben werden.';
                }
                if (!field.fieldCustomParameter.regexValidValue) {
                  return 'Bei Datenfeld ' + n + ' muss ein Beispiel für einen gültigen Inhalt angegeben werden.';
                }
                if (!field.fieldCustomParameter.regexInvalidValue) {
                  return 'Bei Datenfeld ' + n + ' muss ein Beispiel für einen ungültigen Inhalt angegeben werden.';
                }
                if (!field.fieldCustomParameter.regexValidValue.match(this.stringToRegex(field.fieldCustomParameter.regex))) {
                  return 'Bei Datenfeld ' + n + ' ist das Beispiel für einen gültigen Inhalt ungültig.';
                }
                if (field.fieldCustomParameter.regexInvalidValue.match(this.stringToRegex(field.fieldCustomParameter.regex))) {
                  return 'Bei Datenfeld ' + n + ' ist das Beispiel für einen ungültigen Inhalt gültig.';
                }
              }
            }
            if (field.type === 'SELECTION') {
              if (this.isListEmpty(field.fieldCustomParameter.items)) {
                return 'Bei Datenfeld ' + n + ' müssen Auswahlmöglichkeiten angegeben werden.';
              }
            }
            if (field.type === 'SELECTION_PLUS') {
              if (this.isListEmpty(field.fieldCustomParameter.items)) {
                return 'Bei Datenfeld ' + n + ' müssen Auswahlmöglichkeiten angegeben werden.';
              }
              if (field.fieldCustomParameter.sum && field.fieldCustomParameter.items.includes('Summe')) {
                return 'Bei Datenfeld ' + n + ' darf "Summe" keine Auswahlmöglichkeit sein.';
              }
            }
            if (field.type === 'TABLE') {
              if (this.isListEmpty(field.fieldCustomParameter.head)) {
                return 'Bei Datenfeld ' + n + ' müssen die Spalten angegeben werden.';
              }
            }
            if (field.type === 'SELECTION_TABLE') {
              if (this.isListEmpty(field.fieldCustomParameter.options)) {
                return 'Bei Datenfeld ' + n + ' müssen die Optionen angegeben werden.';
              }
              if (this.isListEmpty(field.fieldCustomParameter.items)) {
                return 'Bei Datenfeld ' + n + ' müssen die Optionen angegeben werden.';
              }
            }
            if (field.type === 'FILE') {
              if (this.isListEmpty(field.fieldCustomParameter.fileTypes)) {
                return 'Bei Datenfeld ' + n + ' müssen die erlaubten Dateitypen angegeben werden.';
              }
            }
            if (field.type === 'DESCRIPTION') {
              if (!field.fieldCustomParameter.value) {
                return 'Bei Datenfeld ' + n + ' muss ein Text eingegeben werden.';
              }
            }
            if (field.type === 'NUMBER' || field.type === 'TEXT' || field.type === 'YES_NO' || field.type === 'DATE' || field.type === 'TIME' || field.type === 'PERIOD' || field.type === 'PERCENT' || field.type === 'ROOM' || field.type === 'COST_CENTRE' || field.type === 'ORG_UNIT' || field.type === 'EMPLOYEE_NUMBER' || field.type === 'EMPLOYEE_TYPE' || field.type === 'MOBILE_WORK_AGREEMENT' || field.type === 'DISABILITY_STATUS' || field.type === 'CLIENT' || field.type === 'TELEPHONE' || field.type === 'MOBILE' || field.type === 'FAX' || field.type === 'EMAIL' || field.type === 'SELECTION' || field.type === 'LIST' || field.type === 'SELECTION_PLUS' || field.type === 'PERSON' || field.type === 'ACCOUNT' || field.type === 'PERIODS') {
              if (field.presented) {
                presented = true;
              }
            }
          }
        }
        if (!presented) {
          return 'Mindestens ein Datenfeld muss ausgewählte werden, welches in den Antragsübersichten präsentiert werden soll (Spalte Datenauszug). Am besten wählen Sie ein oder mehrere Pflichtfelder aus, mit denen die Anträge für den Antragssteller unterscheidbar wird.';
        }
        if (this.form.approverTypes?.includes(ApproverType.SELECTED_APPROVER)) {
          const activatedPersonFields = this.form.fields?.filter(field => field.type === FieldType.PERSON && field.fieldCustomParameter.forApproval);
          if (activatedPersonFields?.length !== 1) {
            return 'Es muss ein Feld für die Auswahl von Personen mit der aktivierten Option "Für Genehmigungsweg" vorhanden sein.';
          }
        }
        const activatedCostCentreFields = this.form.fields?.filter(field => field.type === FieldType.COST_CENTRE && field.fieldCustomParameter.forApproval);
        if ((activatedCostCentreFields?.length ?? 0) > 1) {
          return 'Es darf nur ein Feld für die Auswahl von Kostenstellen mit der aktivierten Option "KST für Genehmigungsweg" vorhanden sein.';
        }
        if (this.form.actionType === 'WEBHOOK' && this.form.fields?.filter(field => field.tag?.trim().match(/[^a-z-]+/g)).length) {
          return 'Tags für Felder dürfen nur Kleinbuchstaben und Bindestriche enthalten.';
        }
      }
      if (step === 3) {
        if (this.form.visible) {
          if (!this.form.privacyReason) {
            return 'Es muss der Zweck der Datenverarbeitung angegeben werden.';
          }
        }
      }
    }

    return '';
  }

  createTag(): void {
    if (this.form) {
      if (this.id === 'new' && !this.form.tag && this.form.name) {
        this.form.tag = this.form.name.toLowerCase().trim().replace(/[^a-z]+/g, '-').replace(/^-+/g, '').replace(/-+$/g, '').replace(/-+/g, '-');
      }
    }
  }

  isApproverTypeAvailable(approverType: string, index: number): boolean {
    if (this.form?.approverTypes) {
      if (approverType === ApproverType.CHIEF || approverType === ApproverType.CHIEF_AND_DEPUTY) {
        if (this.form.approverTypes[index] === ApproverType.CHIEF || this.form.approverTypes[index] === ApproverType.CHIEF_AND_DEPUTY) {
          return true;
        }
        return !this.form.approverTypes.includes(ApproverType.CHIEF) && !this.form.approverTypes.includes(ApproverType.CHIEF_AND_DEPUTY);
      }
      if (approverType === ApproverType.COST_CENTRE_RESPONSIBLE || approverType === ApproverType.COST_CENTRE_RESPONSIBLE_AND_DEPUTY) {
        if (this.form.approverTypes[index] === ApproverType.COST_CENTRE_RESPONSIBLE || this.form.approverTypes[index] === ApproverType.COST_CENTRE_RESPONSIBLE_AND_DEPUTY) {
          return true;
        }
        return !this.form.approverTypes.includes(ApproverType.COST_CENTRE_RESPONSIBLE) && !this.form.approverTypes.includes(ApproverType.COST_CENTRE_RESPONSIBLE_AND_DEPUTY);
      }
      if (approverType === ApproverType.DEPARTMENT_CHIEF || approverType === ApproverType.DEPARTMENT_CHIEF_AND_DEPUTY) {
        if (this.form.approverTypes[index] === ApproverType.DEPARTMENT_CHIEF || this.form.approverTypes[index] === ApproverType.DEPARTMENT_CHIEF_AND_DEPUTY) {
          return true;
        }
        return !this.form.approverTypes.includes(ApproverType.DEPARTMENT_CHIEF) && !this.form.approverTypes.includes(ApproverType.DEPARTMENT_CHIEF_AND_DEPUTY);
      }
      if (approverType === ApproverType.MAIN_DEPARTMENT_CHIEF || approverType === ApproverType.MAIN_DEPARTMENT_CHIEF_AND_DEPUTY) {
        if (this.form.approverTypes[index] === ApproverType.MAIN_DEPARTMENT_CHIEF || this.form.approverTypes[index] === ApproverType.MAIN_DEPARTMENT_CHIEF_AND_DEPUTY) {
          return true;
        }
        return !this.form.approverTypes.includes(ApproverType.MAIN_DEPARTMENT_CHIEF) && !this.form.approverTypes.includes(ApproverType.MAIN_DEPARTMENT_CHIEF_AND_DEPUTY);
      }
      if (approverType === ApproverType.DIRECTOR || approverType === ApproverType.DIRECTOR_AND_DEPUTY) {
        if (this.form.approverTypes[index] === ApproverType.DIRECTOR || this.form.approverTypes[index] === ApproverType.DIRECTOR_AND_DEPUTY) {
          return true;
        }
        return !this.form.approverTypes.includes(ApproverType.DIRECTOR) && !this.form.approverTypes.includes(ApproverType.DIRECTOR_AND_DEPUTY);
      }
      if (approverType === ApproverType.DESIGNATED_APPROVER) {
        if (this.form.approverTypes[index] === ApproverType.DESIGNATED_APPROVER) {
          return true;
        }
        return !this.form.approverTypes.includes(ApproverType.DESIGNATED_APPROVER);
      }
      if (approverType === ApproverType.APPROVER_GROUP) {
        if (this.form.approverTypes[index] === ApproverType.APPROVER_GROUP) {
          return true;
        }
        return !this.form.approverTypes.includes(ApproverType.APPROVER_GROUP);
      }
      if (approverType === ApproverType.SELECTED_APPROVER) {
        if (this.form.approverTypes[index] === ApproverType.SELECTED_APPROVER) {
          return true;
        }
        return !this.form.approverTypes.includes(ApproverType.SELECTED_APPROVER);
      }
    }

    return true;
  }

  stringToRegex(regex: string): RegExp {
    return new RegExp(regex);
  }

  isListEmpty(list: string[]): boolean {
    return list.filter(s => s).length === 0;
  }

  requiredChanged(field: Field): void {
    if (!field.required && (field.type === 'COST_CENTRE' || field.type === 'PERSON')) {
      field.fieldCustomParameter.forApproval = false;
    }
  }

  costCentreForceSelectionChanged(field: Field): void {
    if (!field.fieldCustomParameter.forceSelection) {
      field.fieldCustomParameter.forApproval = false;
    }
  }

  costCentreForApprovalChanged(field: Field): void {
    if (field.fieldCustomParameter.forApproval) {
      field.required = true;
      field.fieldCustomParameter.forceSelection = true;
    }
  }

  percentTimeFormatChanged(field: Field): void {
    if (field.fieldCustomParameter.timeFormat) {
      field.fieldCustomParameter.lessThanNull = false;
    }
  }

  percentLessThanNullChanged(field: Field): void {
    if (field.fieldCustomParameter.lessThanNull) {
      field.fieldCustomParameter.timeFormat = false;
    }
  }

  personForApprovalChanged(field: Field): void {
    if (field.fieldCustomParameter.forApproval) {
      field.required = true;
    }
  }

  changeActionType(): void {
    if (this.form) {
      this.form.actionDataCustomParameter = new ActionFormData(undefined);
    }
  }

  openModal(): void {
    this.previewForm = cloneDeep(this.form);
    const ngModal = this.ngModal();
    if (ngModal) {
      this.ngModalService = this.modalService.open(ngModal, { centered: true, backdrop: 'static', size: 'xl' });
    }
  }

  closeModal(): void {
    this.ngModalService?.close();
  }

  checkTypeInField(type: string): boolean {
    if (this.form?.fields) {
      for (const field of this.form.fields) {
        if (field.type && field.type.toString() === type) {
          return true;
        }
      }
    }
    return false;
  }

  checkTypeInApprover(type: string): boolean {
    if (this.form?.approverTypes) {
      for (const field of this.form.approverTypes) {
        if (field && field.toString() === type) {
          return true;
        }
      }
    }
    return false;
  }

  fileTypeSelected(field: Field, fileType: string): boolean {
    return field.fieldCustomParameter.fileTypes.includes(fileType);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  changeFileType(field: Field, option: string, event: any): void {
    if (event.currentTarget?.checked) {
      if (!field.fieldCustomParameter.fileTypes.includes(option)) {
        field.fieldCustomParameter.fileTypes.push(option);
      }
    } else {
      const index: number = field.fieldCustomParameter.fileTypes.indexOf(option);
      if (index !== -1) {
        field.fieldCustomParameter.fileTypes.splice(index, 1);
      }
    }
  }

  checkTag(): void {
    if (this.form?.tag) {
      this.form.tag = this.form.tag.toLowerCase().trim().replace(/[^a-z-]/g, '');
    }
  }

  /*
  startDrag(event: MouseEvent): void {
    // save previous
    this.anchorElement = event.target;
    this.draggedElement = event.target;
    while (!this.draggedElement.classList.includes('drag-element')) {
      this.draggedElement = this.draggedElement.parentNode;
    }
    this.anchorElement.style.cursor = 'grabbing';
    this.draggedElement.style.zIndex = 1200;
    this.mouseStartX = event.clientX;
    this.mouseStartY = event.clientY;
    this.scrollStartX = window.scrollX;
    this.scrollStartY = window.scrollY;
    this.startOffsetX = this.draggedElement.offsetLeft;
    this.startOffsetY = this.draggedElement.offsetTop;
    this.draggedElement.focus();
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('window:mousemove', ['$event'])
  private mouseMoved(event: MouseEvent): void {
    if (this.draggedElement) {
      const diffX = event.clientX - this.mouseStartX + (window.scrollX - this.scrollStartX);
      const diffY = event.clientY - this.mouseStartY + (window.scrollY - this.scrollStartY);
      this.draggedElement.style.left = diffX + 'px';
      this.draggedElement.style.top = diffY + 'px';
      const children = this.draggedElement.parentNode.children;
      let oldIndex = 0;
      for (const c of children) {
        if (c === this.draggedElement) {
          break;
        }
        oldIndex++;
      }
      let newIndex = oldIndex;
      for (let i = oldIndex; i - oldIndex < 4 && i < children.length - 1; i++) {
        const limit = EditorFormComponent.distance(this.startOffsetX, this.startOffsetY, children[i].offsetLeft, children[i].offsetTop) / 3;
        const part = EditorFormComponent.distance(this.draggedElement.offsetLeft, this.draggedElement.offsetTop, children[i].offsetLeft, children[i].offsetTop);
        if (part < limit) {
          newIndex = i;
          break;
        }
      }
      if (newIndex === oldIndex) {
        for (let i = oldIndex; oldIndex - i < 4 && i > 0; i--) {
          const limit = EditorFormComponent.distance(this.startOffsetX, this.startOffsetY, children[i].offsetLeft, children[i].offsetTop) / 3;
          const part = EditorFormComponent.distance(this.draggedElement.offsetLeft, this.draggedElement.offsetTop, children[i].offsetLeft, children[i].offsetTop);
          if (part < limit) {
            newIndex = i;
            break;
          }
        }
      }
      if (newIndex !== oldIndex) {
        // switch elements
      }
    }
  }

  @HostListener('window:mouseup')
  private stopDrag(): void {
    if (this.draggedElement) {
      this.draggedElement.style.top = '0';
      this.draggedElement.style.left = '0';
      this.draggedElement.style.zIndex = '';
      this.anchorElement.style.cursor = 'grab';
      this.draggedElement = null;
      this.anchorElement = null;
      // persist order
    }
  }

  */

  fieldWidth(field: Field): number {
    return field.type === 'HEADER' || field.type === 'SEPARATOR_LINE' || field.type === 'TABLE' || field.type === 'SELECTION_TABLE' ? 12 : (field.type === 'BLANK_SPACE' ? 6 : (field.columnWidth ?? 6));
  }

  addPlusButton(i: number): boolean {
    if (this.form?.fields) {
      const width = this.fieldWidth(this.form.fields[i]);
      return width === 12 || (i > 0 && this.fieldWidth(this.form.fields[i - 1]) === 12) || (i > 1 && !this.addPlusButton(i - 1) && this.addPlusButton(i - 2));
    }
    return false;
  }

  processStyleMarkupWithoutBreaks(s: string | null | undefined): string | null | undefined {
    return s ? this.utilService.processStyleMarkupWithoutBreaks(s) : '';
  }

  getAvailableConditionalTermsByDefinition(o: unknown): string[] {
    const options = o as { fields: Field[]; index: number };

    if (!options.fields) {
      return [];
    }

    const conditionalTerms = [] as string[];
    for (let i = 0; i < options.index; i++) {
      const field = options.fields[i];
      conditionalTerms.push(...(EditorFormComponent.getConditionalTermsByDefinition(field)));
    }
    return uniq(conditionalTerms);
  }

  static getConditionalTermsByDefinition(field: Field): string[] {
    const conditionalTerms = [] as string[];
    if (!field.tag) {
      return conditionalTerms;
    }
    switch (field.type) {
      case FieldType.ACCOUNT:
        conditionalTerms.push(field.tag + '=User');
        conditionalTerms.push(field.tag + '=Extern');
        conditionalTerms.push(field.tag + '=VPN');
        break;
      case FieldType.DISABILITY_STATUS:
      case FieldType.MOBILE_WORK_AGREEMENT:
        conditionalTerms.push(field.tag + '=Ja');
        conditionalTerms.push(field.tag + '=Nein');
        break;
      case FieldType.EMPLOYEE_TYPE:
        conditionalTerms.push(field.tag + '=Fest');
        conditionalTerms.push(field.tag + '=Frei');
        conditionalTerms.push(field.tag + '=Aushilfe');
        conditionalTerms.push(field.tag + '=Extern');
        break;
      case FieldType.SELECTION:
        conditionalTerms.push(...field.fieldCustomParameter.items.map((item: string) => field.tag + '=' + item));
        break;
      case FieldType.YES_NO:
        conditionalTerms.push(field.tag + '=' + (field.fieldCustomParameter.yesLabel ? field.fieldCustomParameter.yesLabel : 'Ja'));
        conditionalTerms.push(field.tag + '=' + (field.fieldCustomParameter.noLabel ? field.fieldCustomParameter.noLabel : 'Nein'));
        break;
    }
    return conditionalTerms;
  }

  usedConditionalTermsByDefinition(field: Field, i: number): string[] {
    if (!field.tag) {
      return [];
    }
    const conditionalTermsByDefinition = EditorFormComponent.getConditionalTermsByDefinition(field);

    const fields = [] as string[];

    for (let n = i + 1; n < (this.form?.fields?.length ?? 0); n++) {
      const f = this.form?.fields?.[n];
      for (const term of f?.conditionalTerms ?? []) {
        if (conditionalTermsByDefinition.includes(term)) {
          fields.push('Datenfeld ' + (n + 1) + ' (' + f?.name + '): ' + term.replace(field.tag + '=', ''));
        }
      }
    }

    return fields;
  }

  protected readonly ActionType = ActionType;
  protected readonly ConditionalType = ConditionalType;
  protected readonly ApproverType = ApproverType;
  protected readonly getLocalizedNameOfApproverType = getLocalizedNameOfApproverType;
  protected readonly getAllApproverTypeValues = getAllApproverTypeValues;
  protected readonly FieldType = FieldType;
}
